const object = {
  id: '5wttbjbm7380apwhegggkhzma',
  type: 'image',
  layout: {
    top: 0,
    left: 0,
    width: '100%',
    height: 210,
    zIndex: 4,
    position: 'absolute',
    marginTop: 0,
    marginLeft: 0,
    right: 0,
  },
  mobile: {
    layout: {
      top: 19,
    },
    attributes: {
      adjustedY: 19,
    },
  },
  tablet: {
    layout: {
      top: 19,
    },
    attributes: {
      adjustedY: 19,
    },
  },
  desktop: {
    layout: {
      top: 19,
    },
    attributes: {
      adjustedY: 19,
    },
  },
  children: [],
  pushGraph: {
    edges: [],
    nodeIds: [],
  },
  attributes: {
    x: 945,
    y: 88,
    name: 'Image 5',
    width: 551,
    height: 210,
    hidden: false,
    zIndex: 4,
    opacity: 1,
    adjustedY: 19,
    imageType: 'dynamic',
    pushGraph: {
      edges: [],
      nodeIds: [],
    },
    filename1x: null,
    borderColor: '#999',
    borderStyle: 'none',
    borderWidth: 1,
    imageResize: 'cover',
    positioning: 'fixedTop',
    borderRadius: 0,
    imageBinding: {
      id: 'ejbhyzqfzyvc5qkrqnj43ic3e',
      type: 'binding',
      source: {
        type: 'field',
        source: {
          type: 'data',
          source: null,
          tableId: 't_bj8806i9m152y7e0djvew0hc8',
          dataType: 'object',
          selector: {
            type: 'LIST_ITEM_SELECTOR',
            listObjectId: '7g2p213p3xjb1xceirwgsbeta',
          },
          datasourceId: '308105675dc349ca9d3c284c86e2a259',
        },
        fieldId: 'c_2kx8tt7nhu7p89ujcfj1p2oja',
        dataType: 'image',
      },
      options: {
        placeholderImage:
          '8b29e3ba2689ad13021243e8ece158aac47855cc0726c823600b02581a26a977.png',
        placeholderImageEnabled: false,
        placeholderImageMetadata: {
          width: 1024,
          height: 1024,
          urlHash: '796ca38cf42d89c5f172bd666acdd53fccf1f8c3',
          blurHash: 'eSQvg^?b?tjI?a?u%fMyRjRi_Lt7ICtQjuj1IBtOxuoN%MIUWTt7M|',
          blurHashWidth: 32,
        },
      },
      bindingType: 'libraryProp',
      childBindings: [],
      siblingBindings: ['bymjz0touteyp4jx4be8y3nwj'],
    },
    initialDevice: 'desktop',
    backgroundColor: '#ddd',
    backgroundStyle: 'none',
  },
  positioning: 'fixedTop',
  responsivity: {
    verticalScaling: 'FIXED',
    horizontalScaling: 'SCALES_WITH_PARENT',
    verticalPositioning: 'TOP',
    horizontalPositioning: 'CENTER',
  },
}

export default object
